export default class ClubApplicationSetting {
    static fromData(data) {
        if (!data) {
            return;
        }

        const clubApplicationSetting = new ClubApplicationSetting();

        clubApplicationSetting.id = data.id || null;
        clubApplicationSetting.active = data.active;
        clubApplicationSetting.contributionRegulationsUrl = data.contributionRegulationsUrl ?? '';
        clubApplicationSetting.dataProtectionUrl = data.dataProtectionUrl ?? '';
        clubApplicationSetting.statuteUrl = data.statuteUrl ?? '';
        clubApplicationSetting.askTitle = data.askTitle;
        clubApplicationSetting.legalRepresentativeAgeLimit = data.legalRepresentativeAgeLimit;
        clubApplicationSetting.askBusinessPhone = data.askBusinessPhone;
        clubApplicationSetting.askBusinessMobile = data.askBusinessMobile;
        clubApplicationSetting.askContractStart = data.askContractStart;
        clubApplicationSetting.askContractStartMandatory = data.askContractStartMandatory;
        clubApplicationSetting.canContractStartBeInPast = data.canContractStartBeInPast;
        clubApplicationSetting.contractStartOnlyMonthly = data.contractStartOnlyMonthly;
        clubApplicationSetting.contractStartOnlyQuarterly = data.contractStartOnlyQuarterly;
        clubApplicationSetting.askDepartments = data.askDepartments;
        clubApplicationSetting.askPassiveContractState = data.askPassiveContractState;
        clubApplicationSetting.allowInvoicePayment = data.allowInvoicePayment;
        clubApplicationSetting.allowSEPAPayment = data.allowSEPAPayment;
        clubApplicationSetting.allowPaymentIntervalSelection = data.allowPaymentIntervalSelection;
        clubApplicationSetting.allowMonthlyPaymentInterval = data.allowMonthlyPaymentInterval;
        clubApplicationSetting.allowQuarterlyPaymentInterval = data.allowQuarterlyPaymentInterval;
        clubApplicationSetting.allowHalfYearlyPaymentInterval = data.allowHalfYearlyPaymentInterval;
        clubApplicationSetting.allowYearlyPaymentInterval = data.allowYearlyPaymentInterval;
        clubApplicationSetting.allowDataUpload = data.allowDataUpload;
        clubApplicationSetting.dataUploadMandatory = data.dataUploadMandatory;
        clubApplicationSetting.dataUploadDescription = data.dataUploadDescription ?? '';
        clubApplicationSetting.askEmergencyContact = data.askEmergencyContact;
        clubApplicationSetting.askAdditionalInformation = data.askAdditionalInformation;
        clubApplicationSetting.askFamilyMembers = data.askFamilyMembers;
        clubApplicationSetting.askCompanyName = data.askCompanyName;
        clubApplicationSetting.askCOAddress = data.askCOAddress;
        clubApplicationSetting.welcomeIntro = data.welcomeIntro;
        clubApplicationSetting.detailsIntro = data.detailsIntro;
        clubApplicationSetting.contactIntro = data.contactIntro;
        clubApplicationSetting.contractIntro = data.contractIntro;
        clubApplicationSetting.paymentIntro = data.paymentIntro;
        clubApplicationSetting.otherIntro = data.otherIntro;
        clubApplicationSetting.fileUploadIntro = data.fileUploadIntro;
        clubApplicationSetting.dogsIntro = data.dogsIntro;
        clubApplicationSetting.askDogs = data.askDogs;
        clubApplicationSetting.askDogMandatory = data.askDogMandatory;
        clubApplicationSetting.askDogChipNumberMandatory = data.askDogChipNumberMandatory;
        clubApplicationSetting.askDogBreedingBookNumberMandatory = data.askDogBreedingBookNumberMandatory;
        clubApplicationSetting.memberFilterFlags = data.memberFilterFlags;
        clubApplicationSetting.memberClassifications = data.memberClassifications;

        return clubApplicationSetting;
    }

    serialize() {
        const clubApplicationSetting = Object.assign({}, this);

        clubApplicationSetting.memberFilterFlags = clubApplicationSetting.memberFilterFlags.filter((f) => f.checked).map((f) => f.id);
        clubApplicationSetting.memberClassifications = clubApplicationSetting.memberClassifications.filter((f) => f.checked).map((f) => f.id);

        return clubApplicationSetting;
    }
}
